import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Dashboard from '@/views/Dashboard'
import Login from '@/views/Login'
import NewTest from '@/views/tests/NewTest'
import OngoingTests from '@/views/tests/OngoingTests'
import FinalisedTests from '@/views/tests/FinalisedTests'
import TestDetails from '@/views/tests/TestDetails'
import Apps from '@/views/competitor/Apps'
import Rates from '@/views/competitor/Rates'
import Leader from '@/views/competitor/Leader'
import UpdateRates from '@/views/competitor/UpdateRates'
import PhoneCodesEdit from '@/views/icg/PhoneCodesEdit'
import ArticleEdit from '@/views/icg/ArticleEdit'
import Content from '@/views/content/Index'
import ContentRecharge from '@/views/content/ContentRecharge'
import ContentICG from '@/views/content/ContentICG'
import Config from '@/views/config/Index'
import ConfigCache from '@/views/config/ConfigCache'
import ConfigRecaptcha from '@/views/config/ConfigRecaptcha'
import Cms from '@/views/cms/Index'
import CmsUploadImage from '@/views/cms/CmsUploadImage'
import { ROLE_WEB_EDITOR, ROLE_COMPETITOR_ANALYST, ROLE_ROUTING_TOOL_EDITOR, ROLE_CMS_EDITOR } from '@/util/constants'

Vue.use(Router)

function requireAuth (to, from, next) {
  store.dispatch('auth/authorize', {}).then(() => {
    var isAuth = store.getters['auth/isAuthenticated']
    if (isAuth) {
      if (to.meta.roles && to.meta.roles.length > 0) {
        let isInRole = false
        to.meta.roles.forEach(function (r) {
          switch (r) {
            case ROLE_WEB_EDITOR:
              if (store.getters['auth/isWebEditor']()) {
                isInRole = true
              }
              break
            case ROLE_COMPETITOR_ANALYST:
              if (store.getters['auth/isCompetitorAnalyst']()) {
                isInRole = true
              }
              break
            case ROLE_ROUTING_TOOL_EDITOR:
              if (store.getters['auth/isRoutingToolEditor']()) {
                isInRole = true
              }
              break
            case ROLE_CMS_EDITOR:
              if (store.getters['auth/isCmsEditor']()) {
                isInRole = true
              }
              break
          }
        })
        if (isInRole) {
          next()
        } else {
          next('/')
        }
      } else {
        next()
      }
    }
  }).catch(() => {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  })
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter (to, from, next) {
        store.dispatch('auth/logout', {}).then(() => {
          window.localStorage.removeItem('routing-tool')
          window.location.href = '/login'
        })
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: requireAuth
    },
    {
      path: '/tests',
      name: 'tests',
      beforeEnter (to, from, next) {
        next('/tests/new')
      }
    },
    {
      path: '/tests/new',
      name: 'newtest',
      component: NewTest,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_ROUTING_TOOL_EDITOR] }
    },
    {
      path: '/tests/ongoing/:currentPage',
      name: 'ongoingtestswithpage',
      component: OngoingTests,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_ROUTING_TOOL_EDITOR] }
    },
    {
      path: '/tests/ongoing',
      name: 'ongoingtests',
      beforeEnter (to, from, next) {
        next('/tests/ongoing/1')
      }
    },
    {
      path: '/tests/finalised/:currentPage',
      name: 'finalisedtestswithpage',
      component: FinalisedTests,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_ROUTING_TOOL_EDITOR] }
    },
    {
      path: '/tests/finalised',
      name: 'finalisedtests',
      beforeEnter (to, from, next) {
        next('/tests/finalised/1')
      }
    },
    {
      path: '/tests/details/:id',
      name: 'testdetails',
      component: TestDetails,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_ROUTING_TOOL_EDITOR] }
    },
    {
      path: '/competitor/apps',
      name: 'competitorApps',
      component: Apps,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_COMPETITOR_ANALYST] }
    },
    {
      path: '/competitor/rates',
      name: 'competitorRates',
      component: Rates,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_COMPETITOR_ANALYST] }
    },
    {
      path: '/competitor/leader',
      name: 'competitorLeader',
      component: Leader,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_COMPETITOR_ANALYST] }
    },
    {
      path: '/competitor/update',
      name: 'competitorUpdateRates',
      component: UpdateRates,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_COMPETITOR_ANALYST] }
    },
    {
      path: '/icg/phonecodes/edit/:id',
      name: 'editPhoneCode',
      component: PhoneCodesEdit,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_WEB_EDITOR] }
    },
    {
      path: '/icg/articles/edit/:locale/:id',
      name: 'editArticle',
      component: ArticleEdit,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_WEB_EDITOR] }
    },
    {
      path: '/content',
      component: Content,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_WEB_EDITOR] },
      children: [
        {
          path: '',
          name: 'content',
          beforeEnter: (to, from, next) => {
            next({ name: 'ContentRecharge' })
          }
        },
        {
          path: 'recharge',
          name: 'ContentRecharge',
          component: ContentRecharge
        },
        {
          path: 'icg',
          name: 'ContentICG',
          component: ContentICG
        }
      ]
    },
    {
      path: '/config',
      component: Config,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_WEB_EDITOR] },
      children: [
        {
          path: '',
          name: 'config',
          beforeEnter: (to, from, next) => {
            next({ name: 'ConfigCache' })
          }
        },
        {
          path: 'cache',
          name: 'ConfigCache',
          component: ConfigCache
        },
        {
          path: 'recaptcha',
          name: 'ConfigRecaptcha',
          component: ConfigRecaptcha
        }
      ]
    },
    {
      path: '/cms',
      component: Cms,
      beforeEnter: requireAuth,
      meta: { roles: [ROLE_CMS_EDITOR] },
      children: [
        {
          path: '',
          name: 'cms',
          beforeEnter: (to, from, next) => {
            next({ name: 'CmsUploadImage' })
          }
        },
        {
          path: 'upload-image',
          name: 'CmsUploadImage',
          component: CmsUploadImage
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js